export const LETTERS = Array(26).fill(0).map((_, i) => String.fromCharCode(i + 65))